import {
  PlanAccountClassification,
  PlanAccountDestination,
  PlanAccountHierarchy,
  PlanAccountImport,
  PlanAccountType,
} from './PlanAccounts.types';

export const planAccountWorkShopMock: PlanAccountImport[] = [
  {
    code: '1000',
    description: 'Receitas',
    hierarchy: PlanAccountHierarchy.Syntetics,
    type: PlanAccountType.General,
    destination: PlanAccountDestination.Revenue,
    subPlanAccounts: [
      {
        code: '1000.0001',
        description: 'Receitas Vendas',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Revenue,
        type: PlanAccountType.General,
      },
      {
        code: '1000.0002',
        description: 'Boletos a Receber',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Revenue,
        type: PlanAccountType.General,
      },
      {
        code: '1000.0003',
        description: 'Cheques a Receber',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Revenue,
        type: PlanAccountType.General,
      },
      {
        code: '1000.0004',
        description: 'Cartão de Crédito',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Revenue,
        type: PlanAccountType.General,
      },
      {
        code: '1000.0005',
        description: 'Cartão de Débito',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Revenue,
        type: PlanAccountType.General,
      },
      {
        code: '1000.0006',
        description: 'Venda de Sucatas',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Revenue,
        type: PlanAccountType.General,
      },
      {
        code: '1000.0007',
        description: 'Venda óleo usado',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Revenue,
        type: PlanAccountType.General,
      },
      {
        code: '1000.0008',
        description: 'Transferência de Entrada',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Revenue,
        type: PlanAccountType.General,
      },
      {
        code: '1000.0009',
        description: 'Ajuste de Saldo',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Revenue,
        type: PlanAccountType.General,
      },
      {
        code: '1000.0010',
        description: 'Receita de Emprestimos',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Revenue,
        type: PlanAccountType.General,
      },
    ],
  },
  {
    code: '2000',
    description: 'Despesas',
    hierarchy: PlanAccountHierarchy.Syntetics,
    type: PlanAccountType.General,
    destination: PlanAccountDestination.Expense,
    classification: PlanAccountClassification.withoutClassification,
  },
  {
    code: '2100',
    description: 'Despesas Administrativas',
    hierarchy: PlanAccountHierarchy.Syntetics,
    type: PlanAccountType.General,
    destination: PlanAccountDestination.Expense,
    classification: PlanAccountClassification.withoutClassification,
    subPlanAccounts: [
      {
        code: '2100.0001',
        description: 'Aluguel',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2100.0002',
        description: 'Energia',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2100.0003',
        description: 'Agua e Saneamento',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2100.0004',
        description: 'Telefonia',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2100.0005',
        description: 'Contabilidade',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2100.0006',
        description: 'Sistema  Gestão',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2100.0007',
        description: 'Correios',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2100.0008',
        description: 'Informática',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2100.0009',
        description: 'Seguro',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2100.0010',
        description: 'Material de Escritório',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2100.0011',
        description: 'Tarifas Bancárias',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2100.0012',
        description: 'Aluguel de Maquineta',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2100.0013',
        description: 'Emprestimos Bancários',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2100.0014',
        description: 'Parcelamento de Impostos',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2100.0015',
        description: 'Material de Limpeza',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
    ],
  },
  {
    code: '2200',
    description: 'Despesas Funcionários',
    hierarchy: PlanAccountHierarchy.Syntetics,
    type: PlanAccountType.General,
    destination: PlanAccountDestination.Expense,
    classification: PlanAccountClassification.withoutClassification,
    subPlanAccounts: [
      {
        code: '2200.0001',
        description: 'Adiantamento Administrativo',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2200.0002',
        description: 'Adiantamento Produtivo',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2200.0003',
        description: 'Salário Administrativo',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2200.0004',
        description: 'Salário Produtivo',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2200.0005',
        description: 'Vale Transporte Administrativo',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2200.0006',
        description: 'Vale Transporte Produtivo',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2200.0007',
        description: 'Vale Refeição Administrativo',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2200.0008',
        description: 'Vale Refeição Produtivo',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2200.0009',
        description: 'Pagamento Férias Administrativo',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2200.0010',
        description: 'Pagamento Férias Produtivo',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2200.0011',
        description: 'Pagamento 13º Salário Administrativo',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2200.0012',
        description: 'Pagamento 13º Salário Produtivo',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2200.0013',
        description: 'Rescisão Trabalhista',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2200.0014',
        description: 'FGTS mensal',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2200.0015',
        description: 'INSS mensal',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2200.0016',
        description: 'FGTS Rescisório',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2200.0020',
        description: 'Hora Extra',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
    ],
  },
  {
    code: '2300',
    description: 'Despesas Variavéis',
    hierarchy: PlanAccountHierarchy.Syntetics,
    type: PlanAccountType.General,
    destination: PlanAccountDestination.Expense,
    classification: PlanAccountClassification.Variable,
    subPlanAccounts: [
      {
        code: '2300.0001',
        description: 'Fornecedores de Peças',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Variable,
        type: PlanAccountType.General,
      },
      {
        code: '2300.0002',
        description: 'Fornecedores de Insumos',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Variable,
        type: PlanAccountType.General,
      },
      {
        code: '2300.0003',
        description: 'Pagamento de Comissão',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Variable,
        type: PlanAccountType.General,
      },
      {
        code: '2300.0004',
        description: 'Juros Bancários',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Variable,
        type: PlanAccountType.General,
      },
      {
        code: '2300.0005',
        description: 'Antecipação de Cartão',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Variable,
        type: PlanAccountType.General,
      },
      {
        code: '2300.0006',
        description: 'Fretes e Carretos',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Variable,
        type: PlanAccountType.General,
      },
      {
        code: '2300.0007',
        description: 'Manutenção de Equipamentos',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Variable,
        type: PlanAccountType.General,
      },
      {
        code: '2300.0008',
        description: 'Reforma e Melhoria Predial',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Variable,
        type: PlanAccountType.General,
      },
    ],
  },
  {
    code: '2400',
    description: 'Impostos/Contribuições',
    hierarchy: PlanAccountHierarchy.Syntetics,
    type: PlanAccountType.General,
    destination: PlanAccountDestination.Expense,
    classification: PlanAccountClassification.Fixed,
    subPlanAccounts: [
      {
        code: '2400.0001',
        description: 'Simples Nacional',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2400.0002',
        description: 'ISS',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2400.0003',
        description: 'IPTU',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2400.0004',
        description: 'ICMS',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
    ],
  },
  {
    code: '2500',
    description: 'Pro Labore',
    hierarchy: PlanAccountHierarchy.Syntetics,
    type: PlanAccountType.General,
    destination: PlanAccountDestination.Expense,
    classification: PlanAccountClassification.Fixed,
    subPlanAccounts: [
      {
        code: '2500.0001',
        description: 'Retirada mensal',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2500.0002',
        description: 'Combustível Proprietário',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2500.0003',
        description: 'Alimentação Proprietário',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
      {
        code: '2500.0004',
        description: 'Outras Retiradas Proprietário',
        hierarchy: PlanAccountHierarchy.Analitical,
        destination: PlanAccountDestination.Expense,
        classification: PlanAccountClassification.Fixed,
        type: PlanAccountType.General,
      },
    ],
  },
];
